import { classNames } from 'helpers/utilities'

export default function AlgoSymbol({ className = '' }) {
  return (
    <span className={classNames('font-algo relative -top-[1px] text-[70%]', className)}>A</span>
  )
}
